<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <navmenu></navmenu>

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-5 col-lg-7 col-md-9 forms card-alerts">
          <form action="">
            <div class="text-center custom-col">
              <h1 class="title-view-2 mb-1">Hello</h1>
              <div class="textInHorizontalLine">
                <span>{{ supplierName }} </span>
              </div>
            </div>
            <div class="card pb-3 mt-4 mb-2" v-if="!requestData">
              <div
                class="col-12"
                v-if="!isAssigned && !isReassigned && !isAnError"
              >
                <p class="p-content-card text-center mb-2">
                  Assign <strong>Driver</strong> for reservation
                  <span class="strong-lg d-block mt-2">
                    {{ reservationNumber }}</span
                  >
                </p>
                <p
                  class="p-content-card text-center mb-4"
                  v-if="drivers.length > 0"
                >
                  To continue, please select a driver or enter a new driver's
                  info.
                </p>
                <p class="p-content-card text-center mb-4" v-else>
                  To continue, please enter the driver's info.
                </p>

                <form role="form" @submit.prevent>
                  <div class="row">
                    <div class="col-12" v-if="drivers.length > 0">
                      <WSelect
                        id="customer_country"
                        name="customer_country"
                        filterable
                        remote
                        reserve-keyword
                        :loading="loading"
                        placeholder="Enter a Driver"
                        v-model="driverId"
                        label="Drivers"
                        @change="selectDriver"
                      >
                        <el-option
                          v-for="driver in drivers"
                          :value="driver._id"
                          :label="
                            `${driver.person.first_name} ${driver.person.last_name}`
                          "
                          :key="driver._id"
                        ></el-option>
                      </WSelect>
                    </div>

                    <div class="col-xl-6 col-lg-4 col-md-4 col-sm-6 col-12">
                      <base-input
                        id="first_name"
                        name="first_name"
                        v-model="driver.person.first_name"
                        label="First Name"
                        placeholder="First Name"
                        maxlength="45"
                        format="capitalize"
                        markrequired
                        :error="
                          !$v.driver.person.first_name.minLength ||
                          $v.driver.person.first_name.$error
                            ? `Enter  ${$v.driver.person.first_name.$params.minLength.min} letters`
                            : ''
                        "
                      />
                    </div>

                    <div class="col-xl-6 col-lg-4 col-md-4 col-sm-6 col-12">
                      <base-input
                        id="last_name"
                        name="last_name"
                        v-model.trim="driver.person.last_name"
                        label="Last Name"
                        placeholder="Last Name"
                        maxlength="45"
                        markrequired
                        format="capitalize"
                        :error="
                          !$v.driver.person.last_name.minLength ||
                          $v.driver.person.last_name.$error
                            ? `Enter ${$v.driver.person.last_name.$params.minLength.min} letters`
                            : ''
                        "
                      />
                    </div>

                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6 mb-4">
                      <label for="title" class="title-label">Gender</label>

                      <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                        <b-form-radio-group
                          v-model="driver.person.gender"
                          :aria-describedby="ariaDescribedby"
                          id="radio-gender"
                          name="radio-gender"
                          buttons
                          button-variant="outline-neutral"
                          size="md"
                        >
                          <b-form-radio value="male" class="pc-1"
                            >Mr.</b-form-radio
                          >
                          <b-form-radio value="female" class="pc-1"
                            >Mrs.</b-form-radio
                          >
                          <b-form-radio value="other" class="pc-1"
                            >Mx.</b-form-radio
                          >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>

                    <div
                      class="col-xl-8 col-lg-6 col-md-7 col-sm-6 col-12 inputphone "
                    >
                      <label
                        class="title-label"
                        v-bind:class="{
                          'is-invalid': $v.driver.person.numbre_phone.$error
                        }"
                        ><span class="markrequired">*</span>Cell Phone</label
                      >
                      <vue-tel-input
                        v-model="phoneNumber"
                        key="NumberPhonedriver"
                        inputId="NumberPhonedriver"
                        name="NumberPhonedriver"
                        required
                        mode="international"
                        inputClasses="input no-label no-err"
                        :dynamicPlaceholder="true"
                        :disabledFetchingCountry="true"
                        :validCharactersOnly="true"
                        :wrapperClasses="[
                          $v.driver.person.numbre_phone.$error
                            ? 'is-invalid'
                            : '',
                          'mb-0'
                        ]"
                        @input="phoneInputMobile"
                      ></vue-tel-input>
                      <small
                        class="invalid-feedback"
                        v-if="$v.driver.person.numbre_phone.$error"
                        >Enter a valid Phone Number</small
                      >
                    </div>

                    <base-alert
                      type="info text-left"
                      class="mb-2 info-min mt-2 p-2"
                    >
                      <i class="flaticon-circle mr-1"></i>
                      If you want to update an existing driver, you just have to
                      select, modify the data and send it
                    </base-alert>
                  </div>

                  <div class="text-center border-top py-2">
                    <base-button
                      type="primary"
                      class="min-button mb-0"
                      :disabled="load"
                      @click="assignDriver()"
                      ><i class="flaticon-send"></i> Send</base-button
                    >
                  </div>
                </form>

                <div class="text-center border-top pt-2">
                  <span class="info-card text-center mb-0 ">
                    For assistance please contact us
                    <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                  </span>
                </div>
              </div>

              <div class="col-12 text-center" v-else>
                <i
                  class="f-30"
                  v-bind:class="[
                    { 'text-success flaticon-check-3': isAssigned },
                    { 'text-danger flaticon-traffic-signal': isReassigned },
                    { 'text-danger flaticon-error': isAnError }
                  ]"
                ></i>

                <p class="p-content-card text-center">
                  Driver for Reservation
                  <span class="strong-lg d-block">
                    {{ reservationNumber }}</span
                  >
                  <span v-if="isAssigned"
                    >has been <strong>Assigned.</strong>
                  </span>
                  <span v-if="isReassigned"
                    >has been reassigned to another partner.
                  </span>
                  <span v-if="isAnError"
                    >couldn't be assigned. An error occurred while processing
                    the request. Please try again or
                    <a href="mailto:info@rhomtrip.com">contact us </a>if the the
                    error persists.</span
                  >
                </p>

                <div class="text-center border-top pt-2">
                  <span class="info-card text-center mb-0 ">
                    For assistance please contact us
                    <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                  </span>
                </div>
              </div>
            </div>
            <div class="loading mt-3" v-else>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
            <div class="loading mt-3" v-if="load">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <layoutFooter class="footer-pages"></layoutFooter>
  </div>
</template>

<script>
import Navbarpages from "@/views/Layout/Navbarpages";
import endpoint from "../Commons/Services/index";
import swal from "sweetalert2";
import layoutFooter from "../Layout/ContentFooter";

import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import moment from "moment";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  components: {
    navmenu: Navbarpages,
    swal,
    layoutFooter: layoutFooter,
    VueTelInput,
    WSelect
  },
  data() {
    return {
      branchId: null,
      supplierName: "",
      reservationNumber: "",
      driverId: "",
      drivers: [],
      load: false,
      driver: {
        person: {
          first_name: "",
          last_name: "",
          full_name: "",
          gender: "",
          phone: ""
        },
        profile: {
          image: ""
        },
        address: {
          country: "",
          state: "",
          city: "",
          street: "",
          postal_code: "",
          house_phone: ""
        },
        license: {
          number: "",
          exppiration: "",
          image: ""
        },
        relationship: {
          type: "in-house",
          branch: "",
          hire_date: moment().format(),
          status: false,
          duty: "off",
          vehicle: null,
          vehicles: [],
          auto_assign: false
        },
        account: {
          email: "",
          status: true
        }
      },
      phoneNumber: "",
      isAssigned: false,
      isReassigned: false,
      isAnError: false,
      loading: false,
      token: "",
      requestData: false
    };
  },
  async created() {
    this.supplierName = this.$route.query.supplierName
      ? this.$route.query.supplierName
      : "";
    this.reservationId = this.$route.params.reservationId;
    this.supplierId = this.$route.params.supplierId;
    this.token = this.$route.query.token;
    await this.getReservationById(this.reservationId);
  },
  methods: {
    async getReservationById(reservationId) {
      try {
        this.requestData = true;
        let { data } = await endpoint.reservations.services.getReservation(
          reservationId,
          this.token
        );
        this.requestData = false;
        if (data.data) {
          let reservation = data.data;
          this.reservationNumber = reservation.booking_number;
          this.supplierName = this.supplierName
            ? this.supplierName
            : reservation.supplier.businessDetails.name;
          let supplierId = reservation.supplier._id;
          if (supplierId !== this.supplierId) {
            this.isReassigned = true;
          }
          this.branchId = reservation.branch._id;
          this.driver.relationship.branch = this.branchId;
          this.drivers = await this.getDriversByBranchId(this.branchId);
        } else {
          this.reservationNumber = "";
          this.supplierName = "";
          this.drivers = [];
        }
      } catch (error) {
        this.requestData = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-error"
        });
      }
    },
    async assignDriver() {
      if (!this.$v.driver.$invalid) {
        if (this.driverId) {
          let driver = await this.updateDriverById(
            this.driverId,
            this.getTempDriver(this.driver)
          );
          await this.assignDriverByReservationId(
            this.reservationId,
            driver._id,
            this.getChauffeur(driver)
          );
        } else {
          this.driver.person.full_name = `${this.driver.person.first_name} ${this.driver.person.last_name}`;
          let driver = await this.createDriver(this.branchId, this.driver);
          await this.assignDriverByReservationId(
            this.reservationId,
            driver._id,
            this.getChauffeur(driver)
          );
        }
      } else {
        this.$v.driver.$touch();
        this.$notify({
          type: "warning",
          title: "Warning",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async assignDriverByReservationId(reservationId, driverId, chauffeur) {
      try {
        this.load = true;
        let {
          data
        } = await endpoint.reservations.services.assignDriverByResevationId(
          reservationId,
          { driverId: driverId, chauffeur: chauffeur },
          this.token
        );
        this.load = false;
        if (data.status) {
          let { action } = data.data;
          if (action) {
            if (action === "assigned") {
              this.isAssigned = true;
            } else if (action === "reassigned") {
              this.isReassigned = true;
            } else {
              this.isAnError = true;
            }
          } else {
            this.isAnError = true;
          }
        } else {
          this.isAnError = true;
        }
      } catch (error) {
        this.load = false;
        this.isAnError = true;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-error"
        });
      }
    },
    phoneInputMobile(value, payload) {
      if (payload.isValid) {
        this.driver.person.numbre_phone = payload.number.e164;
      } else {
        this.driver.person.numbre_phone = value;
      }
    },
    async getDriversByBranchId(branchId) {
      try {
        let { data } = await endpoint.drivers.services.getDriversByBranchId(
          branchId,
          this.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    async createDriver(branchId, driver) {
      try {
        let {
          data
        } = await endpoint.drivers.services.createPartialDriverProfile(
          branchId,
          driver,
          this.token
        );
        if (data.status) {
          return data.data.driver;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    async updateDriverById(driverId, driver) {
      try {
        let { data } = await endpoint.drivers.services.updateAnyAttribute(
          driverId,
          driver,
          this.token
        );
        if (data.status) {
          return data.data.driver;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    selectDriver(driverId) {
      let driver = this.drivers.find(driver => driver._id === driverId);
      if (driver) {
        this.driver.person.first_name = driver.person.first_name;
        this.driver.person.last_name = driver.person.last_name;
        this.driver.person.full_name = driver.person.full_name;
        this.driver.person.gender = driver.person.gender;
        this.driver.person.numbre_phone = driver.person.numbre_phone;
        this.driver.relationship.branch = driver.relationship.branch;
        this.phoneNumber = this.driver.person.numbre_phone;
      }
    },
    getTempDriver(driver) {
      return {
        "person.first_name": driver.person.first_name,
        "person.last_name": driver.person.last_name,
        "person.full_name": driver.person.full_name,
        "person.gender": driver.person.gender,
        "person.numbre_phone": driver.person.numbre_phone,
        "relationship.branch": driver.relationship.branch
      };
    },
    getChauffeur(driver) {
      return {
        name: driver.person
          ? `${driver.person.first_name} ${driver.person.last_name}`
          : "",
        email: driver.account ? driver.account.email : "",
        phone: driver.person ? driver.person.numbre_phone : "",
        gender: driver.person ? driver.person.gender : ""
      };
    }
  },
  validations: {
    driver: {
      person: {
        first_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(20),
          ValName
        },
        last_name: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(20),
          ValName
        },
        numbre_phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        }
      }
    }
  }
};
</script>
